import { SLAVE_AVAILABLE } from './constants';

export const announceSlave = (code, id, features) => ({
  type: SLAVE_AVAILABLE,
  payload: {
    code,
    id,
    features,
  },
});
